import Footer from "@/components/Footer";
import LandingNav from "@/components/LandingNav";
import { AppHeader } from "@/components/AppHeader";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/AuthContext";
import SEOHead from "@/components/SEOHead";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Imprint = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <SidebarProvider defaultOpen={false}>
      <div className="min-h-screen bg-background flex flex-col w-full">
        <SEOHead
          title="Imprint – TestAssets"
          description="Legal imprint and contact information for TestAssets."
          path="/imprint"
          breadcrumbs={[
            { name: "Home", url: "/" },
            { name: "Imprint", url: "/imprint" },
          ]}
        />
        {user ? <AppHeader /> : <LandingNav />}

      <main className="flex-1 container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="text-center space-y-4">
            <p className="text-sm font-medium text-primary uppercase tracking-wider">{t("imprint.tmg")}</p>
            <h1 className="text-4xl font-bold text-foreground">{t("imprint.title")}</h1>
            <p className="text-muted-foreground">{t("imprint.subtitle")}</p>
          </div>

          <div className="space-y-8">
            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.responsible.title")}</h2>
              <div className="space-y-2 text-muted-foreground">
                <p className="font-medium text-foreground">Christoph Schwenk</p>
                <p>c/o flexdienst – #12272</p>
                <p>Kurt-Schumacher-Straße 76</p>
                <p>67663 Kaiserslautern</p>
                <p>{t("imprint.responsible.country")}</p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.contact.title")}</h2>
              <div className="space-y-2 text-muted-foreground">
                <p><strong className="text-foreground">{t("imprint.contact.email")}:</strong> <a href="mailto:support@testassets.io" className="text-primary hover:underline">support@testassets.io</a></p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.responsibleEditorial.title")}</h2>
              <div className="space-y-2 text-muted-foreground">
                <p>{t("imprint.responsibleEditorial.description")}</p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.disputeResolution.title")}</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>{t("imprint.disputeResolution.description")}</p>
                <p>
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="mt-4">{t("imprint.disputeResolution.disclaimer")}</p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.contentLiability.title")}</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>{t("imprint.contentLiability.p1")}</p>
                <p>{t("imprint.contentLiability.p2")}</p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.linkLiability.title")}</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>{t("imprint.linkLiability.p1")}</p>
                <p>{t("imprint.linkLiability.p2")}</p>
              </div>
            </section>

            <section className="bg-card border border-border rounded-lg p-6 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">{t("imprint.copyright.title")}</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>{t("imprint.copyright.p1")}</p>
                <p>{t("imprint.copyright.p2")}</p>
              </div>
            </section>

            <div className="bg-muted border border-border rounded-lg p-6 text-center space-y-4">
              <p className="text-sm text-muted-foreground">
                {t("imprint.privacyLink.text")}{" "}
                <Link to="/privacy-policy" className="text-primary hover:underline">
                  {t("imprint.privacyLink.link")}
                </Link>.
              </p>
              <div>
                <p className="text-sm text-muted-foreground">{t("imprint.footer.compliance")}</p>
                <p className="text-xs text-muted-foreground mt-2">{t("imprint.footer.lastUpdated")}</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      </div>
    </SidebarProvider>
  );
};

export default Imprint;
